import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";
import {CheckboxGroupInputComponent} from "./checkbox-group-input.component";
import {CheckboxInputModule} from '../../checkbox/checkbox-input/checkbox-input.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {LoadingModule} from "../../loading/loading.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        CheckboxInputModule,
        MatCheckboxModule,
        LoadingModule,
    ],
    declarations: [
        CheckboxGroupInputComponent,
    ],
    exports: [
        CheckboxGroupInputComponent
    ],
})
export class CheckboxGroupInputModule {}
